// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__KmMPB","shadow":"styles_shadow__GY8nh"};